import type { WordCollection } from "../collection.types";

export const fogFrostCollection: WordCollection = {
  id: "fog-frost",
  title: "Fog & First Frost",
  icon: "weather-fog",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 10, 1), // November 1st
  endDate: new Date(new Date().getFullYear(), 10, 30), // November 30th
  words: [
    "blanket",
    "brief",
    "cold",
    "damp",
    "delicate",
    "dim",
    "fog",
    "freeze",
    "frost",
    "ghost",
    "hollow",
    "ice",
    "intricate",
    "outline",
    "pale",
    "peaceful",
    "premature",
    "shadow",
    "sharp",
    "silver",
    "solitary",
    "transient",
    "vapor",
    "winter",
  ],
};
